<template>
  <div style="height:100%">
    <TableMain name="one table" ref="notifyTemplateManageRef" :fields="fields" :title="table_title.title1"
      :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
      :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
      :query_button_label="query_lable" @on_query="on_query" @state_change="state_change"
      :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke" @current_changed="current_changed"
      @on_cell_button_click="on_cell_button_click">
      <!-- <template #query>
            角色名称：<el-input size="small" style="width: 120px" v-modal="roleName"></el-input>
          </template> -->
      <template #toolbar="">
        <el-button type="info" plain @click="createForm('new')" style="width: 55px" class="ml-2 iconfont icon-add-new"
          size="mini"></el-button>
      </template>
    </TableMain>

    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData" :size="'md'">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item label="模板类别" prop="category">
            <el-input v-model="dataForm.category"></el-input>
          </el-form-item>
          <el-form-item label="模板类型" prop="notify_type">
            <el-input v-model="dataForm.notify_type" :disabled="disableEdit"></el-input>
          </el-form-item>
          <el-form-item label="模板标题" prop="subject">
            <el-input v-model="dataForm.subject"></el-input>
          </el-form-item>
          <!-- <el-form-item label="通知说明" prop="content">
            <tinymce-editor
              v-model="dataForm.content"
              ref="editor"
            ></tinymce-editor>
          </el-form-item> -->
          <el-form-item label="通知说明" prop="content">
            <editor-bar v-model="dataForm.content"></editor-bar>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as NotifyTemplateManageController from "../../controllers/system/NotifyTemplateManageController"
import BaseContainer from "../components/BaseContainer"
import TestQueryPanel from "../components/base/TestQueryPanel"
import EditorBar from "../components/base/WangEdit"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "PropertyManage",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    EditorBar
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "通知模板列表"
      },
      modal_title: "create_modal",
      fields: NotifyTemplateManageController.fields,
      fields2: NotifyTemplateManageController.fields2,
      dataForm: _.cloneDeep(NotifyTemplateManageController.dataForm),
      rules: NotifyTemplateManageController.rules,
      methods: NotifyTemplateManageController.methods,
      roleName: "",
      items: [],
      selectedItem: null,
      notifyHasData: [],
      notifyNewData: [],
      isBusy: false,
      tab_index: 0,
      disableEdit: false
    }
  },
  created() { },
  methods: {
    //编辑
    async on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.createForm("edit")
    },

    //#region 查询
    async on_query(set_data) {
      set_data([])
      let _dt = await this.methods.GetNotifyTemplates()
      if (!_.isNull(_dt)) {
        set_data(_dt[0])
      }
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_modal"
          this.dataForm = _.cloneDeep(NotifyTemplateManageController.dataForm)
          this.disableEdit = false
          break
        case "edit":
          title = "edite_modal"
          this.disableEdit = true
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    async saveData(cb) {
      let _this = this
      await this.$refs.dataForm.validate(valid => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          _this.addAndUpdate(_data, cb)
        } else {
          cb(false)
          return false
        }
      })
    },
    // 新增或修改
    async addAndUpdate(_data, cb) {
      let _this = this
      //新增时检查是否有type重复
      if (_data.id == "") {
        let _dt = await this.methods.GetNotifyTemplates()
        let all_data = _dt[0]
        let index = _.findIndex(all_data, { notify_type: _data.notify_type })
        if (index > -1) {
          cb(true, false, "通知类型已存在!")
          return
        }
      }
      let b = await this.methods.addAndUpdate(_data)

      if (b) {
        if (_data.id == "") {
          _this.msgToasts(this.$t("notify.action_successfully"), "success")
          //将新增的数据加入到table中
          _this.$refs.notifyTemplateManageRef.my_data.splice(0, 0, {
            id: b[0][0].id,
            notify_type: _data.notify_type,
            category: _data.category,
            subject: _data.subject,
            content: _data.content,
            _current: false,
            _selected: false,
            _id: _data.notify_type
          })
        } else {
          this.msgToasts("编辑成功!", "success")
          //将编辑成功的数据修改到table
          let index = _.findIndex(_this.$refs.notifyTemplateManageRef.my_data, {
            id: _data.id
          })
          if (index > -1) {
            _this.$set(
              _this.$refs.notifyTemplateManageRef.my_data[index],
              "notify_type",
              _data.notify_type
            )
            _this.$set(
              _this.$refs.notifyTemplateManageRef.my_data[index],
              "category",
              _data.category
            )
            _this.$set(
              _this.$refs.notifyTemplateManageRef.my_data[index],
              "subject",
              _data.subject
            )
            _this.$set(
              _this.$refs.notifyTemplateManageRef.my_data[index],
              "content",
              _data.content
            )
          }
        }

        cb(true, true)
      } else {
        if (_data.id == "") {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        } else {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
        cb(true, false)
      }

    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      let _b = await this.methods.UpdateNotify(data)
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts("操作失败！", "error")
      }
      cb(data.state) //回调table操作
    },
    //#endregion

    //#region 打印导出
    // tool_invoke(data, cb) {

    // },
    //#endregion

    current_changed(old, current) { }
  }
}
</script>
<style>
.tox-tinymce-aux {
  z-index: 5000 !important;
}
</style>
